import React from 'react';

import { Box, Typography } from '@mui/material';

import { CommonComponentProps, ImageObject } from '../../pages/types';

interface PageHeaderProps extends CommonComponentProps {
  title?: string;
  subtitle?: string;
  backgroundImage?: ImageObject;
  height?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  id,
  title = '',
  subtitle: paragraph = '',
  backgroundImage,
  height,
  sx,
}) => {
  if (backgroundImage) {
    if (backgroundImage.url)
      backgroundImage.url = backgroundImage.url.replace(/ /g, '%20');
  }

  return (
    <Box
      id={id}
      sx={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: height ? height : '30vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        ...(backgroundImage && {
          backgroundImage: `url(${backgroundImage.url})`,
        }),
        ...sx,
      }}
    >
      <Typography variant="h1" sx={{ paddingBottom: 2 }}>
        {title}
      </Typography>
      <Typography variant="body2">{paragraph}</Typography>
    </Box>
  );
};
export default PageHeader;
